import * as swcHelpers from '@swc/helpers';
import { actions, failedState, successState, loadingState } from '@grandvisionhq/state';
import { getActiveVariant } from '../../../../helpers.js';
import { startPrescriptionGlassesConfiguration } from '../actions.js';
import { fetchLensTypes, fetchLensTypesFailed, fetchLensTypesSuccess, fetchPackages, fetchPackagesFailed, fetchPackagesSuccess, fetchAddOns, fetchAddOnsFailed, fetchAddOnsSuccess } from './actions.js';

const extractSkus = (attributeName)=>{
    return (variant)=>{
        var ref;
        const attribute = (ref = variant.attributes) === null || ref === void 0 ? void 0 : ref.find((a)=>a.name === attributeName
        );
        if (!attribute) {
            return new Set();
        }
        if (Array.isArray(attribute.value)) {
            return new Set(attribute.value);
        } else if (typeof attribute.value === 'string') {
            return new Set(attribute.value.split(','));
        }
        return new Set();
    };
};
const extractLensTypeSkus = extractSkus('compatibleLensTypeProducts');
const extractPackageSkus = extractSkus('compatiblePackageProducts');
const extractAddOnSkus = extractSkus('compatibleOptionProduct');
const extractOpticalParameters = (variant)=>{
    if (!variant.opticalParameters) {
        return {};
    }
    return Object.entries(variant.opticalParameters).reduce((m, [name, value])=>swcHelpers.objectSpread({}, m, {
            [name]: {
                values: value ? new Set(value.values) : new Set()
            }
        })
    , {});
};
const indexVariantsBySku = (products)=>products.reduce((m, p)=>[
            ...m,
            [
                p.masterVariant.sku,
                p.masterVariant
            ],
            ...p.variants.map((v)=>[
                    v.sku,
                    v
                ]
            ), 
        ]
    , []).filter((v)=>!!v[0]
    ).reduce((acc, [sku, v])=>swcHelpers.objectSpread({}, acc, {
            [sku]: v
        })
    , {})
;
const createStates = (skus, stateCreator)=>[
        ...skus
    ].reduce((acc, sku)=>{
        const state = stateCreator(sku);
        if (!state) {
            return acc;
        }
        return swcHelpers.objectSpread({}, acc, {
            [sku]: state
        });
    }, {})
;
const initialState = {
    lensTypes: {},
    packages: {},
    addOns: {},
    frames: {}
};
const reducer = actions.reducer(initialState, /**
   * Initializes a new configuration when necessary
   */ actions.on(startPrescriptionGlassesConfiguration, (s, { payload: { frame , frameSku  }  })=>{
    const variant = getActiveVariant(frame, frameSku);
    return swcHelpers.objectSpread({}, s, {
        frames: {
            [frameSku]: {
                lensTypeSkus: extractLensTypeSkus(variant),
                opticalParameters: extractOpticalParameters(frame.masterVariant)
            }
        }
    });
}), actions.on(fetchLensTypes, (s, a)=>swcHelpers.objectSpread({}, s, {
        lensTypes: swcHelpers.objectSpread({}, s.lensTypes, createStates(a.payload.skus, ()=>loadingState()
        ))
    })
), actions.on(fetchLensTypesFailed, (s, a)=>swcHelpers.objectSpread({}, s, {
        lensTypes: swcHelpers.objectSpread({}, s.lensTypes, createStates(a.payload.skus, ()=>failedState(a.payload.error)
        ))
    })
), actions.on(fetchLensTypesSuccess, (s, a)=>{
    const variantLookup = indexVariantsBySku(a.payload.products);
    return swcHelpers.objectSpread({}, s, {
        lensTypes: swcHelpers.objectSpread({}, s.lensTypes, createStates(a.payload.tried, (sku)=>{
            const variant = variantLookup[sku];
            if (!variant) {
                return;
            }
            return successState({
                packageSkus: extractPackageSkus(variant),
                opticalParameters: extractOpticalParameters(variant)
            });
        }), createStates(a.payload.missing, (sku)=>failedState(new Error(`Couldn't find lens type with SKU "${sku}"`))
        ))
    });
}), actions.on(fetchPackages, (s, { payload: { skus  }  })=>swcHelpers.objectSpread({}, s, {
        packages: swcHelpers.objectSpread({}, s.packages, createStates(skus, ()=>loadingState()
        ))
    })
), actions.on(fetchPackagesFailed, (s, a)=>swcHelpers.objectSpread({}, s, {
        packages: swcHelpers.objectSpread({}, s.packages, createStates(a.payload.skus, ()=>failedState(a.payload.error)
        ))
    })
), actions.on(fetchPackagesSuccess, (s, a)=>swcHelpers.objectSpread({}, s, {
        packages: swcHelpers.objectSpread({}, s.packages, createStates(a.payload.tried, (sku)=>{
            const product = a.payload.products.find((p)=>p.masterVariant.sku === sku
            );
            if (!product) {
                return;
            }
            return successState({
                addOnSkus: extractAddOnSkus(product.masterVariant)
            });
        }), createStates(a.payload.missing, (sku)=>failedState(new Error(`Couldn't find package with SKU "${sku}"`))
        ))
    })
), actions.on(fetchAddOns, (s, { payload: { skus  }  })=>swcHelpers.objectSpread({}, s, {
        addOns: swcHelpers.objectSpread({}, s.addOns, createStates(skus, ()=>loadingState()
        ))
    })
), actions.on(fetchAddOnsFailed, (s, a)=>swcHelpers.objectSpread({}, s, {
        addOns: swcHelpers.objectSpread({}, s.addOns, createStates(a.payload.skus, ()=>failedState(a.payload.error)
        ))
    })
), actions.on(fetchAddOnsSuccess, (s, a)=>swcHelpers.objectSpread({}, s, {
        addOns: swcHelpers.objectSpread({}, s.addOns, createStates(a.payload.tried, ()=>successState(undefined)
        ), createStates(a.payload.missing, (sku)=>failedState(new Error(`Couldn't find add-on with SKU "${sku}"`))
        ))
    })
));

export { extractAddOnSkus, extractLensTypeSkus, extractPackageSkus, initialState, reducer };
//# sourceMappingURL=reducer.js.map
